<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-template-emails-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-template-emails-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-template-emails-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="disabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-template-emails-list>
    <div class="modal-footer">
      <button class="btn btn-default" (click)="closeModal()">
        Fermer
      </button>
    </div>
  </ng-template>
</div>